import React, { useEffect, useState } from 'react'
import { AuthService } from '@pw-tech/web-sdk'
import { ThemeProvider } from '@pw-tech/omni-ui'
import AmbassadorRoutes from 'routes'
import { Loader } from '@corecomponents/ui'
import './App.css'
import { LocationProvider } from '@context/LocationContext'
import { BatchPlusModalProvider } from '@context/BatchPlusContext/BatchPlusContext'
import { Toaster } from 'react-hot-toast'
import AUTH_CONFIG from 'web-sdk-config'
import { RoutingListner } from '@container/RoutingListener/RoutingListener'

const App = () => {
  const [webSDKInitialize, setWebSDKInitialize] = useState(false)
  useEffect(() => {
    AuthService.getInstance(AUTH_CONFIG)
    console.log('AuthService', AuthService.getInstance(AUTH_CONFIG))

    setWebSDKInitialize(true)
  }, [])
  return webSDKInitialize ? (
    <LocationProvider>
      <Toaster />
      <ThemeProvider>
        <BatchPlusModalProvider>
          <RoutingListner />
          <AmbassadorRoutes />
        </BatchPlusModalProvider>
      </ThemeProvider>
    </LocationProvider>
  ) : (
    <div className="w-full h-[100vh] flex justify-center items-center text-center">
      <Loader></Loader>
    </div>
  )
}

export default App
